

import { getIntersectionRoot } from '@theme/scroll-container';

const observers = new Map();
const pendingCarousels = new WeakSet();

async function initProcladUgc(root) {
  const carousel = root.querySelector('[data-proclad-ugc-swiper]');
  if (carousel && !carousel.swiper) {
    if (pendingCarousels.has(carousel)) return;
    pendingCarousels.add(carousel);
    let Swiper;
    try {
      ({ default: Swiper } = await import('@theme/swiper'));
    } finally {
      pendingCarousels.delete(carousel);
    }
    if (!root.isConnected || carousel.swiper) return;
    new Swiper(carousel, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      watchOverflow: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
      },
      breakpoints: {
        750: {
          spaceBetween: 16,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1025: {
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 56,
        },
      },
    });
  }

  if (root.dataset.ugcSoundReady === 'true') return;
  root.dataset.ugcSoundReady = 'true';
  const cards = [...root.querySelectorAll('.proclad-ugc__card')];
  cards.forEach((card) => {
    const btn = card.querySelector('[data-ugc-sound]');
    const video = card.querySelector('video');
    if (!btn || !video) return;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const unmuting = video.muted;
      if (unmuting) {

        root.querySelectorAll('video').forEach((v) => {
          if (v !== video) v.muted = true;
        });
        root.querySelectorAll('[data-ugc-sound]').forEach((b) => {
          if (b !== btn) {
            b.setAttribute('aria-pressed', 'false');
            b.setAttribute('aria-label', 'Unmute video');
          }
        });
      }
      video.muted = !unmuting;
      btn.setAttribute('aria-pressed', unmuting ? 'true' : 'false');
      btn.setAttribute('aria-label', unmuting ? 'Mute video' : 'Unmute video');
      if (unmuting && video.paused) {
        const host = video.closest('video-source');
        if (host && !host.loaded) host.load();
        video.play().catch(() => {});
      }
    });
  });
}

function initAllUgc() {
  document.querySelectorAll('[data-proclad-ugc]').forEach((root) => {
    if (observers.has(root) || root.dataset.ugcSoundReady === 'true') return;
    if (!('IntersectionObserver' in window)) {
      void initProcladUgc(root);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      observers.delete(root);
      void initProcladUgc(root);
    }, { root: getIntersectionRoot(), rootMargin: '400px 0px' });
    observers.set(root, observer);
    observer.observe(root);
  });
}
initAllUgc();
document.addEventListener('shopify:section:load', initAllUgc);
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-proclad-ugc]').forEach((root) => {
    observers.get(root)?.disconnect();
    observers.delete(root);
  });
  event.target.querySelector('[data-proclad-ugc-swiper]')?.swiper?.destroy(true, true);
});


